export default {
    OPEN_CREATION_MODAL(state, value) {
          state.creationModal.isOpen = value;
          state.creationModal.data.name = null;
          state.creationModal.data.id = null;
          state.creationModal.data.enabled = true;
    },
    SET_CREATE_MODAL_DATA(state, data) {
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
          state.creationModal.data[keys[i]] = data[keys[i]];
        }
    },
    SET_OPEN_CHANGELOG(state, value) {
        state.changelogOpen = value;
    },
    SET_LOGS_DATA(state, data) {
        state.logs = data;
    },
    SET_CREATE_MODAL_ERRORS (state, data) {
        state.creationModal.errors = data;
    },
}
